import React from "react"

const IndexPage = () => <>General index page</>

export default IndexPage
